export default {
  name: 'regExp',

  // HTML 주석 추출
  htmlCommentSingle: /<!--(.*?)-->/gm,

  // 자연수 (0 제외, 1부터 시작)
  naturalNumber: /^[1-9]\d*$/,

  // 이메일 검증
  expEmail: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,

  // 전화번호 형식 (지역번호 포함)
  expPhone: /^\d{2,3}-\d{3,4}-\d{4}$/,

  // 아이디 (영문 + 숫자 포함, 6~20자리)
  expId: /(?=.*\d)(?=.*[a-z]).{6,20}/,

  // 비밀번호 (영문 + 숫자 + 특수문자 포함, 9~20자리)
  expPassword: /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{9,20}$/,

  // 휴대폰 번호 (010, 011, 016, 017, 018, 019 지원)
  regPhone: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,

  // 이미지 확장자 검증
  imageFormat: /(png|jpeg|svg|jpg|gif)$/,

  /**
   * 숫자만 추출
   * @param {string|number} num - 입력값
   * @returns {string} 숫자만 포함된 문자열
   */
  numberOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },

  /**
   * 숫자에 콤마 추가 (3자리 단위)
   * @param {string|number} num - 입력값
   * @returns {string} 콤마가 삽입된 문자열
   */
  comma: function (num) {
    const reg = /^([-+]?\d+)(\d{3})(\.\d+)?/
    let string = '' + (num != null ? num : '')
    string = string.replace(/[^-+.\d]/g, '')
    while (reg.test(string)) string = string.replace(reg, '$1' + ',' + '$2' + '$3')
    return string
  },

  /**
   * 숫자에서 콤마 제거
   * @param {string|number} str - 입력값
   * @returns {string} 콤마가 제거된 문자열
   */
  uncomma: function (str) {
    str = String(str)
    return str.replace(/[^-.\d]/g, '')
  },

  /**
   * 모든 공백 제거 후 소문자 변환
   * @param {string} str - 입력 문자열
   * @returns {string} 공백 제거 및 소문자 변환된 문자열
   */
  replaceAllEmpty: function (str) {
    return str.replace(/(\s*)/g, '').toLowerCase()
  },

  /**
   * 이름 마스킹 (가운데 글자 * 처리)
   * @param {string} str - 이름 문자열
   * @returns {string} 가운데 글자가 *로 마스킹된 문자열
   */
  maskingName: function (str) {
    const replace = function (str, index, char) {
      return str.substr(0, index) + char + str.substr(index + char.length)
    }
    const index = parseInt(str.length / 2)
    return replace(str, index, '*')
  },

  /**
   * 아이디 마스킹 (마지막 5자리 * 처리)
   * @param {string} str - 아이디 문자열
   * @returns {string} 마지막 5자리가 *로 마스킹된 문자열
   */
  maskingId: function (str) {
    const replace = function (str, length, char) {
      const result = []
      for (let i = 0; i < str.length; i++) {
        result.push(i < str.length - length ? str[i] : char)
      }
      return result.join('')
    }
    return replace(str, 5, '*')
  },

  /**
   * 전화번호 마스킹 (가운데 자리 * 처리)
   * @param {string} phone - 전화번호 (xxx-xxxx-xxxx 형식)
   * @returns {string} 가운데 자리가 *로 마스킹된 전화번호
   */
  maskingPhone: function (phone) {
    phone = phone.split('-')
    const replace = function (str, char) {
      return str.replace(/[0-9]/g, char)
    }
    return `${phone[0]}-${replace(phone[1], '*')}-${phone[2]}`
  }
}
